import api from './api';

interface SsoTokenResponse {
  success: boolean;
  data: {
    token: string;
    redirectUrl: string;
  };
}

interface ChatStatusResponse {
  success: boolean;
  data: {
    available: boolean;
    url: string;
  };
}

/**
 * Chat service for Campfire integration
 */
export const chatService = {
  /**
   * Get SSO token and redirect URL for Campfire authentication
   * @returns Promise with token and redirect URL
   */
  getSsoToken: async (): Promise<{ token: string; redirectUrl: string }> => {
    const response = await api.post<SsoTokenResponse>('/chat/sso-token');
    return response.data.data;
  },

  /**
   * Check if chat service is available
   * @returns Promise with availability status and URL
   */
  getStatus: async (): Promise<{ available: boolean; url: string }> => {
    const response = await api.get<ChatStatusResponse>('/chat/status');
    return response.data.data;
  },

  /**
   * Open chat in a new window/tab with SSO authentication
   * Falls back to direct URL if SSO fails
   */
  openChat: async (): Promise<void> => {
    try {
      const { redirectUrl } = await chatService.getSsoToken();
      window.open(redirectUrl, '_blank', 'noopener,noreferrer');
    } catch (error) {
      console.error('Failed to get SSO token, falling back to direct URL:', error);
      // Fallback to direct URL without SSO
      const status = await chatService.getStatus();
      window.open(status.url, '_blank', 'noopener,noreferrer');
    }
  },
};

export default chatService;
